const prefix = 'features/blockchain-101';

export const BLOCKCHAIN_101 = `${prefix}/BLOCKCHAIN_101`;
